const topics = [
  { name: '韩漫', heat: '362万', icon: 'ri-flag-2-line', color: 'bg-primary-100 text-primary-700' },
  { name: '日漫', heat: '458万', icon: 'ri-global-line', color: 'bg-accent-100 text-accent-700' },
  { name: '国漫', heat: '289万', icon: 'ri-map-pin-2-line', color: 'bg-secondary-200/80 text-secondary-800' },
  { name: '恋爱', heat: '215万', icon: 'ri-heart-line', color: 'bg-primary-100 text-primary-700' },
  { name: '热血', heat: '198万', icon: 'ri-fire-line', color: 'bg-accent-100 text-accent-700' },
  { name: '奇幻', heat: '176万', icon: 'ri-magic-line', color: 'bg-secondary-200/80 text-secondary-800' },
  { name: '悬疑', heat: '143万', icon: 'ri-search-eye-line', color: 'bg-primary-100 text-primary-700' },
  { name: '搞笑', heat: '231万', icon: 'ri-emotion-laugh-line', color: 'bg-accent-100 text-accent-700' },
  { name: '古风', heat: '127万', icon: 'ri-brush-line', color: 'bg-secondary-200/80 text-secondary-800' },
  { name: '完结', heat: '312万', icon: 'ri-check-double-line', color: 'bg-primary-100 text-primary-700' },
  { name: '新作', heat: '89万', icon: 'ri-sparkling-line', color: 'bg-accent-100 text-accent-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-100/50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8">
          话题标签
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#"
              onClick={(e) => e.preventDefault()}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all hover:scale-105 cursor-pointer ${topic.color}`}
            >
              <i className={`${topic.icon} text-base`}></i>
              <span className="whitespace-nowrap">{topic.name}</span>
              <span className="text-xs opacity-70 font-normal">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}